<template>
	<dropdown class='npa-violation-dropdown form-control height-control' v-model='val' @input='open' :disabled='npa_disabled' :text='names'>
		<li>
			<checkbox type='info' v-model='sel'>Выбрать всё</checkbox>
		</li>
		 <li role="separator" class="divider"></li>
		 <table class='npa-violation-table'>
		 	<thead>
		 		<th></th>
		 		<th>НПА</th>
		 		<th>Нарушение</th>
		 	</thead>
		 	<tbody>
		 		<tr v-for='i in items'>
		 			<td class='npa-violation-td-checkbox'><checkbox type='info' class='npa-violation-checkbox' v-model='i.checked' @input='check(i.id, i.name, i.checked)'></checkbox></td>
		 			<td>{{i.name}}</td>
		 			<td>{{i.violation}}</td>
		 		</tr>
		 	</tbody>
		 </table>
	<!-- 	<li>
		
	</li>
	 <li role="separator" class="divider"></li>
	<li class='pull-right'>
		<input type="button" class='btn btn-primary' value='Ок' @click='ok'></input>
		<input type="button" class='btn btn-default' value='Отмена' @click='cancel'></input>
	</li> -->
	</dropdown>
</template>

<script>
	import { dropdown, checkbox } from 'vue-strap'
	import { EventBus } from '../../../lib/EventBus'
	import moment from 'moment';
	import {DB} from './../../../constants'

	const NPA_VIOLATION = 'get_npa_violation_new.php'
	const ACT_INFO = 'get_act_info.php'
	const WARRANT_INFO = 'get_warrant_info.php'

	export default {
		name: 'npaViolation',
		data () {
			return {
				items: [],
				names: '',
				names_obj: {},
				val: false,
				sel: false,
				formattedDate: ""
			}
		},
		props: {
			npa_disabled: false,
			ids: ''
		},
		components: {
			dropdown,
			checkbox
		},
		watch: {
			sel (e) {
				this.items.map(t => {
					t.checked = e
				})
			},
		},
		methods: {
			check(id,name,value) {
				if (value)
					this.names_obj[id] = name
				else
					this.names_obj[id] = null

				let text = ''
				let ids = []
				for (let key in this.names_obj) {
					if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
						text += this.names_obj[key] + ', '
						ids.push(key)
					}
				}

				text = text.slice(0, -2)

				if (text.length > 105)
					this.names = text.slice(0,105) + '...'
				else
					this.names = text

				//console.warn(ids)
				EventBus.$emit('warrant_npa_violation_ids', ids)
			},
			open (show) {
				if (show) {
					let _ids = ''
					for (let i = 0; i < this.ids.length; i++) {
						_ids += this.ids[i]
					}

					_ids = _ids.slice(1,-1).split(',')
					for (let i = 0; i < _ids.length; i++) {
						for (let j = 0; j < this.items.length; j++) {
							if (_ids[i] == this.items[j].id) {
								this.items[j].checked = true
							}
						}
					}
				}
				
			},
			fill (ids) {
				fetch(DB + NPA_VIOLATION + "?date=" + this.formattedDate)
				.then(res => res.json())
				.then(res => {
					if (res) {
						let arr = res.map(r => {
							return {
								id: r.id,
								name: r.name,
								violation: r.violation,
								checked: false
							}
						})

						if (typeof ids != 'undefined') {
							let text = ''
							for (let i = 0; i < ids.length; i++) {
								for (let j = 0; j < arr.length; j++){
									if (ids[i] == arr[j].id) {
										text += arr[j].name + ', '
									}
								}
							}

							text = text.slice(0, -2)

							if (text.length > 105)
								this.names = text.slice(0,105) + '...'
							else
								this.names = text
						}

						this.items = arr
					}
					else {
						this.items = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		created () {
			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(res => {
				const act_date = moment(res[0].f_3, "YYYY-MM-DD")
				if(act_date.isValid()) {
					this.formattedDate = act_date.format("DD.MM.YYYY")
				} else {
					this.formattedDate = moment().format("DD.MM.YYYY")
				}

				fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					return res[0].f_92
				})
				.then(ids => {
					if (ids) {
						ids = ids.slice(1,-1).split(',')
						this.fill(ids)
					}
					else {
						this.fill()
					}
				})
			})
		}
	}

</script>

<style>
.npa-violation-dropdown {
	border: 1px solid;
	width: 100%;
	padding: 0 !important;
}

.npa-violation-dropdown > button.dropdown-toggle {
	font-weight: normal;
	/*font-size: 12px;*/
}

.npa-violation-dropdown > ul.dropdown-menu {
	min-width: 860px !important;
	top: auto !important;
	bottom: 100% !important;
	margin-bottom: 2px !important;
	max-height: 500px;
	overflow-x: auto;
}

/*.npa-violation-dropdown > button > span.caret {
	float: right;
}
*/
.npa-violation-table {
	width: 100%;
	height:100%;
}

.npa-violation-table tr {
	height: 30px;
}

.npa-violation-table td.npa-violation-td-checkbox {
	width: 30px;
	min-width: 30px;
}

.npa-violation-checkbox {
	margin-top: 0px !important;
	margin-bottom: 18px !important;
	margin-left: 7px !important;
}

/*ul.dropdown-menu {
	padding-left: 10px;
	padding-right: 10px;
	max-height: 500px;
	min-width: 200px;
	overflow-y: auto;
}*/
</style>


// WEBPACK FOOTER //
// npaViolation.vue?dd9e35be